import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControlService } from '../form-control.service';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';

import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import { EmailFormControlService } from './email-form-control.service';

@Component({
  selector: 'ss-email-form-control',
  templateUrl: './email-form-control.component.html',
  styleUrls: ['./email-form-control.component.css'],
  providers: [
    EmailFormControlService,
    FormControlService,
    createControlValueAccessorProvider(EmailFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit {

  readonly validationMessageSubject = this._formControlService.validationMessageSubject;

  inputKeyStream!: Observable<KeyboardEvent>

  constructor(
  ) {
    super()
  }

  ngOnInit(): void {

  }



  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();

  }

}


